import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import LeadDetailPage from "./pages/LeadDetailPage";
import ReportsPage from "./pages/ReportsPage";
import AdminPage from "./pages/AdminPage";
import SettingsPage from "./pages/SettingsPage";
import OutreachPage from "./pages/OutreachPage";
import ApproveLinkPage from "./pages/ApproveLinkPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import CallReminders from "./components/CallReminders";
import { Crown } from "lucide-react";

function Loading() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#0B1120]">
      <Crown className="w-10 h-10 text-amber-500 animate-pulse" />
      <p className="text-slate-400 text-sm">Loading…</p>
    </div>
  );
}

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) {
    sessionStorage.setItem("returnTo", window.location.pathname + window.location.search);
    return <Navigate to="/login" replace />;
  }
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/unsubscribe" element={<UnsubscribePage />} />
            <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/leads/:id" element={<Protected><LeadDetailPage /></Protected>} />
            <Route path="/app/reports" element={<Protected><ReportsPage /></Protected>} />
            <Route path="/app/outreach" element={<Protected><OutreachPage /></Protected>} />
            <Route path="/app/outreach/approve/:id" element={<Protected adminOnly><ApproveLinkPage /></Protected>} />
            <Route path="/app/team" element={<Protected adminOnly><AdminPage /></Protected>} />
            <Route path="/app/settings" element={<Protected><SettingsPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CallReminders />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
